import { Contract } from 'Interfaces/Contract';
import { createReducer } from 'typesafe-actions';

import { getFormRequestContracts } from './actionCreators';

export default createReducer({} as Contract).handleAction(
  getFormRequestContracts.success,
  (state, action) => ({
    ...action.payload.contracts,
  }),
);
